import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant", "className", "componentType"];
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import classnames from 'classnames';
import { createTypographyTheme, ROOT_PREFIX } from './typographyStyles';
var EXCLUDED_VARIANTS = ['subtitle3', 'subtitle4', 'body', 'bodyLink', 'button1', 'button2', 'button2Uppercase', 'button1Uppercase', 'small', 'smallUppercase', 'eyebrow', 'eyebrowUppercase'];
export var EmbersTypography = function EmbersTypography(_ref) {
  var variant = _ref.variant,
    className = _ref.className,
    componentType = _ref.componentType,
    props = _objectWithoutProperties(_ref, _excluded);
  var _variant = !EXCLUDED_VARIANTS.includes(variant) ? variant : 'inherit';
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: createTypographyTheme(componentType)
  }, /*#__PURE__*/React.createElement(Typography, _extends({}, props, {
    variant: _variant,
    className: classnames('EmbersTypography-root', _defineProperty({}, "".concat(ROOT_PREFIX, "-").concat(variant), variant), className)
  })));
};